<template>
  <div>
    <div class="container container-fluid">
      <div class="c-listing-header">
        <div class="c-listing-header__cta-container">
          <h2 class="c-listing-header__heading">Hospital Maps Development</h2>
          <span class="h-flex"></span>
        </div>
      </div>

      <p class="c-listing-header__subheading">Front End</p>
      <p>Cookie Name: "EventManualZipcodeEntry"</p>

      <ul>
        <li>Created a utility js script, src/app/utils/aha-cookie.js.</li>
        <li>Vue component: aha-hospital-zipcode-modal will detect if cookie exist on mounted.</li>
        <li>If no cookie, or zipcode is null then have modal pop up asking for zipcode then store zipcode in the cookie.</li>
        <li>Cookie API to get, set cookie with cookie name and zipcode as parameters, delete cookie.</li>
        <li>Demo page: demo/pages/layouts/hospitalmaps.vue</li>
      </ul>

      <!-- Modal -->
      <!-- Button -->

      <br />
      <br />

      <div class="d-flex">
        <button v-b-modal.ahaZipCodeModal class="btn btn-lg btn-danger btn-round">
          Trigger
          Zip Code Modal
        </button>
        <div>&nbsp;</div>
        <a
          v-on:click.prevent="clearCookie"
          class="btn btn-lg btn-danger btn-round text-white"
        >Clear Cookie</a>
      </div>

      <br />
      <br />

      <!-- component -->
      <aha-hospital-zipcode-modal
        ref="zipcode-modal"
        name="zipcode-modal"
        zip-code-selector="address_42"
        :translations="{
                'cookie': 'EventManualZipcodeEntry',
                'btn': 'Share', 
                'heading': 'Share Your Location', 
                'subheading': 'We cannot determine your location, please share your Zip Code to view accredited hospitals in your area.',
            }"
      ></aha-hospital-zipcode-modal>
      <!-- end component -->

      <pre>
        <!-- component -->
        &lt;aha-hospital-zipcode-modal
          ref="zipcode-modal"
          name="zipcode-modal"
          zip-code-selector="zipcode" // the id of the zip code input box for Coveo search
          :translations="{ 
                'cookie': 'EventManualZipcodeEntry',
                'btn': 'Share', 
                'heading': 'Share Your Location', 
                'subheading': 'We cannot determine your location, please share your Zip Code to view accredited hospitals in your area.',
            }"
        &gt;&lt;/aha-hospital-zipcode-modal&gt;
      </pre>

      <p class="c-listing-header__subheading">Coveo Search Box</p>

      <div class="container c-map-search">
        <aha-map-search 
                name="location-selector" 
                endpoint="//jsonplaceholder.typicode.com/posts" 
                :translations='{ "search": "Search", "searchResults": "Search results for", "clearResults": "Clear Results", "offices": "Offices", "address": "Address", "city": "City", "distance": "Distance", "searchLabel": "Hospital Name", "searchAddressLabel": "Hospital Address", "searchLabelPlaceholder": "i.e. Presbyterian", "addressLabelPlaceholder": "i.e. Address", "distancePlaceholder": "Distance" }'
                :distances='[{ "code": "5", "title": "5 Miles" }, { "code": "10", "title": "10 Miles" }, { "code": "20", "title": "20 Miles" }]'>
            </aha-map-search>
      </div>

      <!-- Leon's Design -->
      <!-- Coveo Search -->
      <div class="container c-map-search">
        <div class="c-map-search__content">
          <form
            novalidate="novalidate"
            class="map-location-search"
            name="location-selector"
            search-endpoint="//jsonplaceholder.typicode.com/posts"
          >
            <div class="map-search__fields row">
              <div class="form-group col-md-4">
                <label for="zipcode">Search Hospital Name or Address</label>
                <input
                  name="hospital"
                  type="text"
                  placeholder="i.e. Presbyterian"
                  class="form-control form-control-lg"
                  id="zipcode"
                />
              </div>
              <div class="form-group col-md-4">
                <label for="distance_147">Distance</label>
                <select
                  name="distance"
                  class="custom-select btn--select form-control form-control-lg"
                  id="distance_147"
                >
                  <option value>Select a Distance</option>
                  <option value="5">5 Miles</option>
                  <option value="10">10 Miles</option>
                  <option value="20">20 Miles</option>
                </select>
              </div>
              <div class="col-md-4">
                <button
                  type="submit"
                  class="c-map-search__search-btn btn btn-lg btn-danger btn-round"
                >Search</button>
              </div>
            </div>
          </form>
        </div>
      </div>

      <br />
      <br />
    </div>
    <!-- End contaier -->
  </div>
</template>

<script>
import { Cookie } from "@/utils/aha-cookie";
export default {
  data() {
    return {};
  },
  created() {
    document.addEventListener("DOMContentLoaded", function() {
      // Coveo.SearchEndpoint.configureSampleEndpointV2();
      var root = document.getElementById("search");
      //alert("hello");
      Coveo.SearchEndpoint.endpoints["default"] = new Coveo.SearchEndpoint({
        restUri: "https://platform.cloud.coveo.com/rest/search",
        accessToken: "xx09c92f34-189d-4f13-85af-6e3a207f2f13"
      });
      Coveo.$$(root).on("buildingQuery", function(e, args) {
        args.queryBuilder.expression.add("heart attack");
      });
      Coveo.init(root);
    });
  },

  mounted() {
    //this.showModal();
    // this.$nextTick(function() {
    // });
  },
  methods: {
    clearCookie: function() {
      Cookie.deleteCookie("EventManualZipcodeEntry");
      window.location.reload();
      Cookie.getAllCookies();
    },
    showModal: function() {
      //this.$refs["zipcode-modal"].showModal();
    }
  }
};
</script>
<style scoped>
pre {
  background-color: #eaeaea;
  font-size: 0.5rem;
}
</style>


// WEBPACK FOOTER //
// demo/pages/layouts/hospitalmaps.vue